const mutations = {
  ["ExcelCheckBoxesNamesMut"](state, payload) {
    state.ExcelCheckBoxesNames = payload;
  },
};
export default mutations;
